<!--Pagination-->
<nav aria-label="pagination example"
  [ngClass]="!(paging.totalItems > 0 && paging.totalItems > paging.pageSize) && 'hidden'">
  <ul class="pagination pg-blue justify-content-end">

    <!--Arrow left-->
    <li class="page-item" *ngIf="paging.totalPage <= 5">
      <span class="page-link" (click)="paging.totalPage > 1 && paging.first()">
        Trang Đầu
      </span>
    </li>
    <li class="page-item" *ngIf="paging.totalPage > 5" [ngClass]="paging.pageBefore === 1 ? 'disabled-button' : ''">
      <span class="page-link" (click)="paging.changePage(paging.pageCurrent - 5)">
        <i aria-hidden="true" class="fa fa-step-backward"></i>
      </span>
    </li>
    <li class="page-item">
      <span class="page-link" [ngClass]="!paging.checkPrevious() ? 'disabled-button' : ''" (click)="paging.previous()">
        <i class="fa fa-caret-left fa-lg" aria-hidden="true"></i>
      </span>
    </li>
    <li class="page-item" *ngFor="let item of paging.pages; index as index">
      <span class="page-link" (click)="paging.changePage(item)"
        [ngClass]="item === paging.pageBefore ? 'active-link background-active-link' : ''">
        {{item}}
        <span class="sr-only">(current)</span>
      </span>
    </li>
    <li class="page-item">
      <span class="page-link" [ngClass]="!paging.checkNext() ? 'disabled-button' : ''" (click)="paging.next()">
        <i class="fa fa-caret-right fa-lg" aria-hidden="true"></i>
      </span>
    </li>
    <li class="page-item" *ngIf="paging.totalPage > 5"
      [ngClass]="paging.pageBefore === paging.totalPage ? 'disabled-button' : ''">
      <span class="page-link" (click)="paging.changePage(paging.pageCurrent + 5)">
        <i aria-hidden="true" class="fa fa-step-forward"></i>
      </span>
    </li>
    <li class="page-item" *ngIf="paging.totalPage <= 5">
      <span class="page-link" (click)="paging.totalPage > 1 && paging.last()">
        Trang Cuối
      </span>
    </li>
  </ul>
</nav>